export const SliderData = [
  {
    image:
      "https://raw.githubusercontent.com/speedbuild98/frontend-dev-challenge/bb4ef0c245a8e77bcb94eb72995b2e814f0dc079/src/assets/sliderImage3.svg",
  },
  {
    image:
      "https://raw.githubusercontent.com/speedbuild98/frontend-dev-challenge/bb4ef0c245a8e77bcb94eb72995b2e814f0dc079/src/assets/sliderImage2.svg",
  },
  {
    image:
      "https://raw.githubusercontent.com/speedbuild98/frontend-dev-challenge/bb4ef0c245a8e77bcb94eb72995b2e814f0dc079/src/assets/sliderImage1.svg",
  },
];
